export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || '';
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
export const HOST_API_URL = "";
  //ENVIRONMENT === 'prod' ? process.env.REACT_APP_HOST_API_URL_PROD : process.env.REACT_APP_HOST_API_URL_DEV;
